import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { LandmarkPanel } from '@form/lm-form.model';
import { lmCardViewFormatter } from '@list/formatters/lm-card-view.formatter';
import { LMFormatterService } from '@list/formatters/lm-formatter.service';
import { LMListCardService } from '@list/services/lm-list-card.service';
import { LMFormatUtilService } from '@services/utils/lm-format-util.service';
import { LMThemeService } from '@banner/lm-theme.service';
import { LMUrlUtilService } from '@services/utils';
import { AppConstants } from '@utils/app.constants';
import { LMGlobalPersonalizationService } from '@app/states';
import { LMTwelveColumnPanelBaseComponent } from './lm-twelve-column-panel-base.component';

@Component({
  selector: 'lm-twelve-column-panel-card',
  templateUrl: './lm-twelve-column-panel-card.component.html',
})

export class LMTwelveColumnPanelCardComponent extends LMTwelveColumnPanelBaseComponent implements OnInit {
  @HostBinding() public id;

  @Input() panel: LandmarkPanel;
  @Input() messageRuleView: LMDataView;

  @Input() set fromDataView(dataView) {
    this._dataView = dataView;
    this.build();
  };

  @Output() uiLinkEvent = new EventEmitter<any>();

  public columnInfo: string;
  public overNavigationLink: string;
  public hasOverviewNavigation: boolean;
  public displayLinkAsText: boolean;

  private _dataView: LMDataView;
  public isInAccessibilityMode: boolean;

  constructor(
    private lmFormatterService: LMFormatterService,
    private lmListCardService: LMListCardService,
    private lmFormatUtilService: LMFormatUtilService,
    protected lmThemeService: LMThemeService,
    private lmUrlUtilService: LMUrlUtilService,
    private lmGlobalPersonalizationService: LMGlobalPersonalizationService
  ) {
    super(lmThemeService);
  }

  savePanelState(): void {}

  clearPanelState(): void {}

  ngOnInit() {
    this.isInAccessibilityMode = this.lmGlobalPersonalizationService.getAccessibilityMode();
    this.build();

    this.id = this.panel.id + AppConstants.ELEMENT_ID_SUFFIX_DASHBOARDPANEL;

    if (this.panel.overviewNavigation) {
      this.hasOverviewNavigation = true;
      if (this.panel.overviewNavigation.label) {
        this.displayLinkAsText = true;
      }
    }
  }

  build() {
    if (this.panel && this._dataView) {
      this.columnInfo = this.LMCardViewFormatter(0, 0, 0, { displayField: this.panel.displayFields[ 0 ] }, this._dataView, null);
      if (this.panel.overviewNavigation && this.panel.overviewNavigation.label) {
        this.overViewNavigationLabel();
      }
      this._setContentClasses(this.panel);
    }
  }

  overViewNavigationLabel() {
    const dataView = this.fromDataView ? this.fromDataView : this.messageRuleView;
    this.overNavigationLink = this.lmFormatUtilService.formatMessageRule(this.panel.overviewNavigation.label, dataView);
  }

  // eslint-disable-next-line max-len
  LMCardViewFormatter = (row: number, cell: number, value: any, columnDef: ListGridColumn, dataView: LMDataView, dataGrid: SohoDataGridStatic): string => lmCardViewFormatter.format(this.lmFormatterService, this.lmListCardService, this.lmUrlUtilService, row, cell, value, columnDef, dataView, dataGrid, 'lm-dashboard-card-container');

  onNavigationClick(event, displayField?: LMListDisplayField) {
    let df: LMListDisplayField;

    if (displayField === undefined) {
      df = {
        columnId: '',
        fieldId: '',
        type: '',
        navigation: this.panel.overviewNavigation.name
      };
    } else {
      df = displayField;
    }

    const uiLink: LMUILinkEvent = {
      columnDef: { displayField: df },
      dataView: this._dataView,
      event,
      options: { fromDashboard: true }
    };

    this.uiLinkEvent.emit(uiLink);
  }

  onWidgetContentClick(event) {
    if (event && event.target.nodeName === 'A' && event.target.dataset.displayfield !== undefined) {
      this.onNavigationClick(event, JSON.parse(event.target.dataset.displayfield));
    }
  }
}
